import { put, select } from "redux-saga/effects";
import { API } from 'aws-amplify';
import { getResponseData } from '../../utils/apiHelpers';

import ConvertCoordinates from '../../shared/ConvertCoordinates';
import GetPolygonCenter from '../../shared/GetPolygonCenter';

import * as actions from "../actions";
import * as selectors from "../selectors/selectors";
import { handleApiError } from '../../utils/apiErrorHandler';

export function* getPlaseSaga(action) {
    try {
        let apiName = 'AWSApiGateway';
        let path = '/plase?fields=id,naam,grens';
        const response = yield API.get(apiName, path, { response: true });
        var plase = [...getResponseData(response, [])];
        for (const plaas of plase) {
            plaas.coordinates = plaas.grens ? ConvertCoordinates(plaas.grens) : [];
            delete plaas.grens;
        }
        // console.log(plase);
        yield put(actions.setPlase(plase));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getPlaseFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* getAlleBlokkeSaga(action) {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/blokke?seisoen=${action.seisoenid}&fields=id,naam,grens,plaas`;
        const response = yield API.get(apiName, path, { response: true });
        let blokke = [];
        if (getResponseData(response, []).length > 0) {
            blokke = [...getResponseData(response, [])];
            for (const blok of blokke) {
                blok.coordinates = blok.grens ? ConvertCoordinates(blok.grens) : [];
                delete blok.grens;
            }
        }
        yield put(actions.setAlleBlokke(blokke));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getBlokkeFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* getBlokkeSaga(action) {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/blokke?seisoen=${action.seisoenid}&fields=id,naam,grens&plaasid=${action.plaasid}`;
        const response = yield API.get(apiName, path, { response: true });
        yield put(actions.setBlokke(getResponseData(response, [])));
    } catch (error) {
        console.log(error);
        const errordata = handleApiError(error, { context: 'saga' });
        console.log(errordata);
        yield put(actions.getBlokkeFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
    }
}

export function* getPlaasSaga(action) {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/plase?id=${action.plaasid}`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            throw new Error(204);
        } else {
            yield put(actions.setPlaas(getResponseData(response, [])[0]));
        }
    } catch (error) {
        if (error.message == 204) {
            // console.log(error.message);
            yield put(actions.getPlaasFailed({ status: 204 }, "Geen data kon gevind word nie", 204, ""));
        } else {
            console.log(error);
            const errordata = handleApiError(error, { context: 'saga' });
            console.log(errordata);
            yield put(actions.getPlaasFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
        }
    }
}

export function* getBlokSaga(action) {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/blokke?id=${action.blokid}`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            throw new Error(204);
        } else {
            yield put(actions.setBlok(getResponseData(response, [])[0]));
        }
    } catch (error) {
        if (error.message == 204) {
            // console.log(error.message);
            yield put(actions.getBlokFailed({ status: 204 }, "Geen data kon gevind word nie", 204, ""));
        } else {
            console.log(error);
            const errordata = handleApiError(error, { context: 'saga' });
            console.log(errordata);
            yield put(actions.getBlokFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
        }
    }
}

export function* getEenheidVerhSaga(action) {
    try {
        let apiName = 'AWSApiGateway';
        let path = `/opstellings/PLUK?kategorie=PLUK_EENHEDEVERH`;
        const response = yield API.get(apiName, path, { response: true });
        // console.log(response);
        if (response.status === 204 || getResponseData(response, []).length < 1) {
            throw new Error(204);
        } else {
            yield put(actions.setEenheidVerhoudings(getResponseData(response, [])[0]));
        }
    } catch (error) {
        if (error.message == 204) {
            // console.log(error.message);
            yield put(actions.getEenheidVerhoudingsFailed({ status: 204 }, "Geen data kon gevind word nie", 204, ""));
        } else {
            console.log(error);
            const errordata = handleApiError(error, { context: 'saga' });
            console.log(errordata);
            yield put(actions.getEenheidVerhoudingsFailed(errordata, "Iets het skeefgeloop...", errordata.code, errordata.message));
        }
    }
}

export function* plaasCenter(action) {
    if (action.plaas) {
        const plase = yield select(selectors.plase);
        const index = plase.map(item => item.id).indexOf(action.plaas.value);
        const coordinates = plase[index].coordinates;
        let center = GetPolygonCenter(coordinates);
        yield put(actions.setCenter(center));
    }
}